import { render } from "./bakindex.vue?vue&type=template&id=3b32249c&scoped=true"
import script from "./bakindex.vue?vue&type=script&lang=js"
export * from "./bakindex.vue?vue&type=script&lang=js"

import "./bakindex.vue?vue&type=style&index=0&id=3b32249c&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b32249c"]])

export default __exports__